<template>
  <b-container class="m-auto p-8">
    <b-row>
      <b-col lg="7" id="right-box">
        <slot name="p-1"></slot>
      </b-col>
      <b-col lg="5" class="position-relative left">
        <div class="left-box p-3">
          <slot name="p-2"></slot>
         </div>
      </b-col>

      <div id="b-box"></div>
    </b-row>


  </b-container>
</template>

<script>
export default {
  name: "S900",

};
</script>
<style>

</style>

<style scoped>


.left-box {

  height: 100px;
  position: absolute;


  transform: translate(0%, 6%);
}

#b-box:empty {
  position: absolute;
  background-color: var(--secondary);
  z-index: 1;
}

@media screen and (min-width: 769px) {

  .left {
    background-color: var(--primary);
    margin-right: -25px;
    margin-top: -80px;
    height: 382px;
    width: 382px;
    z-index: 3;
  }
}

@media screen and (max-width: 769px) {
  .left {
    background-color: var(--primary);
    height: 300px;
    margin-top: -10px;
    margin-right: 20px;
    width: 260px;
    z-index: 3;
  }
}

@media screen and (max-width: 426px) {

  #b-box:empty {
    height: 650px;
    width: 150px;

    transform: translate(-60%, -20%);

  }
}

@media screen and (min-width: 426px )and (max-width: 768px) {
  #b-box:empty {
    height: 600px;
    width: 200px;

    transform: translate(-80%, -20%);

  }
}

@media screen and (min-width: 768px )and (max-width: 992px) {
  #b-box:empty {
    height: 700px;
    width: 300px;

    transform: translate(-80%, -20%);

  }
}

@media screen and (min-width: 992px )and (max-width: 1024px) {
  #b-box:empty {

    height: 500px;
    width: 300px;

    transform: translate(-150%, -20%);

  }
}

@media screen and (min-width: 1024px) {

  #b-box:empty {
    height: 500px;
    width: 300px;

    transform: translate(-140%, -20%);

  }
}


#right-box {
  z-index: 2;
}


.p-8 {
  padding-top: 75px;
}



</style>